import ApiService from '@/services/core/api.service'

const CommentService = {
  async get (payment, params = {}) {
    return ApiService.get(`cash-management-officer/check-approvals/${payment}/comments`, { params })
  },

  async post (payment, payload) {
    return ApiService.post(`cash-management-officer/check-approvals/${payment}/comments`, payload)
  },

  async put (payment, payload) {
    return ApiService.put(`cash-management-officer/check-approvals/${payment}/comments/${payload.id}`, payload)
  },

  async delete (payment, payload) {
    return ApiService.delete(`cash-management-officer/check-approvals/${payment}/comments/${payload.id}`, {
      data: payload
    })
  }
}

export default CommentService
